module.exports = __webpack_public_path__ + "img/360_num_2.63dc0565.png";